import React from 'react';
import cx from 'classnames';
import styles from './styles.scss';

const propTypes = {};
const defaultProps = {};

const MediaGalleryThumbnailPlaceholder = () => (
  <>
    <div className={styles.thumbnailContainer}>
      <div className={cx(styles.thumbnail, styles.placeholder)} />
    </div>
    <div className={styles.trashHeader}>
      Trash
    </div>
    <div className={styles.trashDescription}>
      {`Move files you no longer need here.  They'll stay in the trash until you empty
      it.  Permanently deleted files cannot be restored.`}
    </div>
  </>
);

MediaGalleryThumbnailPlaceholder.propTypes = propTypes;
MediaGalleryThumbnailPlaceholder.defaultProps = defaultProps;


export default MediaGalleryThumbnailPlaceholder;
